<!-- 出库详情 -->
<template>
  <article>
    <tab-list
      :tab-list="tabList"
      :status.sync="tabstatus"
      class="usedcar-status">
    </tab-list>
    <!-- 出库信息-->
    <p class="outbound_status">{{statusInfo[outBoundStatus]}}</p>
    <section v-if="tabstatus === 'car_detail'">

    <group class="item_car_info">
      <cell :bdStart="true" class="ob_car_info">
        <div slot="icon" class="info_img">
          <img :src="outBoundInfo.car_info.car_image">
        </div>
        <div slot="after-title" class="info_detail">
          <p>{{outBoundInfo.car_info.car_model_name}}</p>
          <p class="info_status">车架号：{{outBoundInfo.car_info.vin}}</p>
          <p class="info_status">车牌号：{{outBoundInfo.car_info.plate_number}}</p>
        </div>
      </cell>
    </group>
    <outbound-config
      class="auction-order"
      :hide-pic="true"
      :type="typeCode"
      :info="outBoundInfo.ob_request">
    </outbound-config>

    <group>
      <cell title="车辆详情"
        :link="`/auction/outbound/carinfo/${obRequestId}?from=outBoundReview`">
      </cell>
    </group>

    <steps :traces="traces">
      <div slot-scope="{ step }">
        <p class="trace_title_info">
          <span class="trace_title">{{step.title}}</span>
          <span class="trace_time" v-if="step.operated_at">{{step.operated_at}}</span>
        </p>
        <div v-if="step.operator_name">
          <p>经手：{{step.operator_name}}（{{step.role_names}}）</p>
          <p>电话：<a :href="`tel:${step.mobile}`" class="i_phone">{{step.mobile}}</a></p>
          <p v-if="step.review_note">备注：{{step.review_note}}</p>
        </div>
      </div>
    </steps>
    </section>
    <!-- 凭证照片 -->
    <section class="previewer_list" v-if="tabstatus === 'car_images'">
      <div class="list_title">
        <p>凭证照片（如合同、收款信息、买家身份证等）</p>
      </div>
      <ul class="list_images" v-if="images.length > 0">
        <li v-for="(item, i) in images" :key="i">
          <p class="item_title" v-if="typeCode === 'retail'">{{item.name}}</p>
          <img class="item_img" :src="item.src" @click.stop="onClick(i)">
        </li>
      </ul>
      <p v-else class="non_images">无</p>
      <images-previewer :list="images" ref="previewer" :options="options"></images-previewer>
    </section>
    <!-- 根据角色和状态选择显示 -->
    <section class="btn-bottom submit-btn" v-if="btnInPermissions.length > 0">
      <div class="btn-fix">
        <a class="btn"
          v-for="(item, index) in btnInPermissions"
          :key='index'
          @click.stop="operate(item.value)">
          {{item.name}}
        </a>
      </div>
    </section>
  </article>
</template>
<script>
import { Group, Cell } from '@lx-frontend/cvux'
import ImagesPreviewer from '@lx-frontend/images-previewer'
import OutboundConfig from './components/OutboundConfig'
import TabList from '../components/TabList'
import Steps from '../components/Steps'
import cache from '../../common/cache'
import util from '../../common/util'
import url from '../../common/url'

export default {
  components: {
    Group,
    Cell,
    // Previewer,
    ImagesPreviewer,
    TabList,
    OutboundConfig,
    Steps
  },
  data() {
    return {
      obRequestId: '',
      tabstatus: 'car_detail',
      managerAuth: false,
      financialAuth: false,
      tabList: [
        { key: 'car_detail', name: '出库信息' },
        { key: 'car_images', name: '凭证照片' }
      ],
      outBoundStatus: '',
      typeCode: '',
      statusInfo: {
        created: '待二手车经理审核',
        manager_approved: '待财务审核',
        manager_rejected: '二手车经理已驳回',
        financial_approved: '财务审核已通过',
        financial_rejected: '财务审核已驳回'
      },
      outBoundInfo: {
        car_info: {},
        ob_request: {}
      },
      traces: [],
      images: [],
      imgCount: 0,
      options: {
        // fullscreenEl: true,
        getThumbBoundsFn(index) {
          // find thumbnail element
          let thumbnail = document.querySelectorAll('.item_img')[index]
          // get window scroll Y
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          // optionally get horizontal scroll
          // get position of element relative to viewport
          let rect = thumbnail.getBoundingClientRect()
          // w = width
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          }
          // Good guide on how to get element coordinates:
          // http://javascript.info/tutorial/coordinates
        }
      }
    }
  },
  created() {
    this.$store.state.promiseAuth.then(auth => {
      this.managerAuth = auth.authList.includes('used_car_outbound.review.business')
      this.financialAuth = auth.authList.includes('used_car_outbound.review.financial')
    })
    this.obRequestId = this.$route.params.id
    this.$rest.outBound.getManageList(null, this.obRequestId).then(res => {
      if (res.code === 0) {
        let titles = {
          retail: '零售出库申请',
          batch_sale: '批售出库申请',
          scrap: '报废出库申请',
          special: '特殊出库申请'
        }
        let imgList = res.data.ob_request.images
        this.outBoundStatus = res.data.ob_request.status_code
        this.typeCode = res.data.ob_request.type_code
        util.changeTitle(titles[this.typeCode])
        this.outBoundInfo = res.data
        this.traces = this.getTracesData(this.outBoundInfo.traces)
        if (imgList.length > 0) this.images = this.render(imgList)
      } else {
        this.showToast(res.message)
      }
    })
  },
  computed: {
    btnInPermissions() {
      let result = []
      let allBtnList = [
        { value: 'reject', name: '驳回' },
        { value: 'approve', name: '通过' },
        { value: 'resubmit', name: '重新提交' }
      ]
      let isSubmitter = this.outBoundInfo.ob_request.is_submitter
      switch (this.outBoundStatus) {
        case 'created': // 待二手车经理审核
          if (this.managerAuth) result = allBtnList.splice(0, 2)
          break
        case 'manager_approved':
          if (this.financialAuth) result = allBtnList.splice(0, 2)
          break
        case 'manager_rejected': // 待审核状态和是否为本员工
        case 'financial_rejected':
          if (isSubmitter) result = allBtnList.splice(2)
          break
        default:
          result = []
      }
      return result
    }
  },
  methods: {
    getTracesData(list = []) {
      let tracesTitle = {
        pending_review: '审核',
        approved: '审核通过',
        rejected: '驳回',
        not_started: '审核'
      }
      // 审核列表加标题
      list.forEach((v, i) => {
        if (i === 0) v.title = '提交出库'
        if (i === 1) v.title = `二手车经理${tracesTitle[v.status]}`
        if (i === 2) v.title = `财务${tracesTitle[v.status]}`
      })
      return list
    },
    render(arr = []) {
      arr.map((v, i) => {
        let img = new window.Image()
        img.src = v.src
        // 如果图片被缓存，则直接返回缓存数据
        if (img.complete) {
          v.w = img.width
          v.h = img.height
          this.imgCount++
        } else {
          // 完全加载完毕的事件
          img.onload = () => {
            v.w = img.width
            v.h = img.height
            this.imgCount++
          }
        }
      })
      return arr
    },
    onClick(index) {
      if (this.imgCount === this.images.length && this.$refs.previewer) {
        this.$refs.previewer.show(index)
      }
    },
    operate(action) {
      if (action === 'resubmit') { // 重新出库提交
        // 缓存出库提交表单
        cache.setSessionData('OUTBOUND_FROM_DATA', this.outBoundInfo.ob_request)
        this.$router.push({
          path: `/outbound/${this.typeCode}/${this.outBoundInfo.car_info.car_id}`
        })
      } else { // 通过或者驳回
        let role = {
          created: 'manager',
          manager_approved: 'financial'
        }
        this.$router.push({
          path: `/outbound/review/${this.obRequestId}/${action}/${role[this.outBoundStatus]}`
        })
      }
    }
  },
  watch: {
    outBoundInfo (val) {
      const typeName = decodeURIComponent(url.getSearch().type_name)
      const title = typeName === 'undefined' ? '二手车跟进' : `${typeName}申请`
      const carInfo = val.car_info
      const desc = `${carInfo.car_model_name} ${carInfo.plate_number}`
      const imgUrl = carInfo.car_image
      this.shareFriend({
        title,
        desc,
        imgUrl
      })
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/outbound/manageList.less";
@import "../../stylesheets/modules/components/previewer.less";
</style>
